import { gql } from "@apollo/client";

export const getMarketplacesQuery = gql`
  query GetMarketplaces($pagination: PaginationInfo, $filter: GetListFilter) {
    getMarketplaces(pagination: $pagination, filter: $filter) {
      marketplaces {
        id
        name
        disabled
        validated
      }
      totalCount
    }
  }
`;

export const getMarketplaceQuery = gql`
  query GetMarketplace($id: Float!) {
    getMarketplace(id: $id) {
      id
      name
      disabled
      validated
      validationFailReasons
      isInvoicePullInitialized
      firstInvoiceCycleDate
      config {
        account {
          hopReturnUrl
          marketplaceOperatorEmails
          manageBlockPaymentFlags
          noOfSellerQuestions
          unsuspendNewShops
          useSubscription
          useBalancePlatforms
          useChannels
          useCommision
          onlyIdReferenceForBeneficiary
          usePreBalancePlatforms
          invoiceSyncScheduler {
            description
            value
          }
          accountFullSyncScheduler {
            description
            value
          }
          accountPartialSyncScheduler {
            description
            value
          }
          maxInvoiceRetryCount
          locale
          miraklSsoEnabled
        }
        mirakl {
          url
          key
          ssoClientId
          ssoClientSecret
        }
        blacklists {
          shops
          invoices
        }
      }
      channels {
        id
        code
        config{
          hopOptions{
            allowBankAccountFormatSelection,
            allowIntraRegionCrossBorderPayout
          }
          routePriorities
          enablePreLiableCommissions
        }
        isDefault
        marketplaceId
        balancePlatform
        preBalanceAccountId
        preBalancePlatformName
        lemApi {
          url
          isBasicAuth
          user
          password
          key
        }
        balanceApi {
          url
          isBasicAuth
          user
          password
          key
        }
        balanceAccountId
        notificationUrl
        notificationSettings {
          configuration {
            user
            password
            hmac
          }
          transfer {
            user
            password
            hmac
          }
          transferInstrument {
            user
            password
            hmac
          }
          legalEntity {
            user
            password
            hmac
          }
        }
      }
    }
  }
`;
